































































import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";

@Component
export default class WHomeAbout extends BaseComponent {}
